import React from "react";
import { Link } from "react-router-dom";

export const PrimaryLink = ({
  href,
  children,
  target = "",
  className = "",
}) => (
  <Link
    to={href}
    target={target}
    rel="noopener noreferrer"
    className={`flex items-center justify-center w-max h-fit bg-gradient-to-r from-quaternary to-tertiary text-white hover:to-secondary hover:from-secondary transition px-6 py-2 text-base font-bold rounded-lg text-center ${className}`}
  >
    {children}
  </Link>
);

export const SecondaryLink = ({ href, children, target, className = "" }) => (
  <Link
    to={href}
    target={target}
    rel="noopener noreferrer"
    className={`flex items-center justify-center px-6 py-2 border h-fit w-max bg-white hover:bg-gray-100 text-black rounded-lg text-base font-bold ${className}`}
  >
    {children}
  </Link>
);

export const LinkWithoutBg = ({
  href,
  children,
  target = "",
  className = "",
  scroll
}) => (
  <Link
    to={href}
    target={target}
    rel="noopener noreferrer"
    scroll={scroll}
    className={`hover:text-primary text-secondary transition font-bold ${className}`}
  >
    {children}
  </Link>
);
